<template>
<main>
<!-- <keep-alive> -->
            <!-- <div v-for="add in ads" :key="add.id">
                <div v-html="add.adcode"></div>
                

            </div> -->
            <!-- <div id="gist">
                <adsense
  ad-client="ca-pub-0756076699379568"
  ad-slot="2172411856"
  ad-style="display: block"
  ad-format="auto">
</adsense>
            </div> -->
                <div>
                    <!-- <VueScriptComponent script='
<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>

<ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-0756076699379568"
     data-ad-slot="2172411856"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script>
'>
</VueScriptComponent> -->
<div v-for="add in ads" :key="add.id">
<VueScriptComponent :script="add.adcode">
</VueScriptComponent>
</div>
<div id="adsgoeshere" style="background: #1d1f29; padding-top:60px; text-align: center;" v-html="adsenseContent"></div>
            <!-- <script2 type="text/javascript" id="5y3ycw8b5a_6_25">
(function() {
var e=document.createElement('script');
e.src='https://graphics.adrecord.com/5y3ycw8b5a_6_25.js';
var s=document.getElementsByTagName('body')[0]; s.appendChild(e);
})();
</script2> -->
</div>
<!-- </keep-alive> -->
</main>
</template>

<script>
import axios from "axios";
import store from "../store";
import VueScriptComponent from 'vue-script-component'
export default {
    props: ["theme"],
    components: {
    VueScriptComponent
  },
    data: function() {
        return {
            store: store,
            adsenseContent: '',
            ads : null
        };
    },
    mounted: function () {
        this.adsenseContent = document.getElementById('divadsensedisplaynone').innerHTML
    //     let scriptTag = document.createElement('script')
    //     scriptTag.async = true
    //     scriptTag.setAttribute('id', '5y3ycw8b5a_6_25')
    //     scriptTag.onload = () => {
    //     (function(){
    //     var e=document.createElement('script');
    //     e.src='https://graphics.adrecord.com/5y3ycw8b5a_6_25.js';
    //     var s=document.getElementsByTagName('body')[0]; s.appendChild(e);
    //     })();
    //     }
    //     document.getElementById('static').appendChild(scriptTag)
    },
    created: async function() {
        if (this.theme) {
            var resp = await axios.get(
                `${this.store.state.baseURL}getadds/${this.theme}`
            );
        } else resp = await axios.get(`${this.store.state.baseURL}getadds/11`);
        this.ads = resp.data.add
    }
};
</script>

<style></style>
